import { FontLevels } from '../models';
const fonts = {
    stacks: {
        primary: 'Vodafone, Arial, sans-serif',
        secondary: 'Vodafone, Arial, sans-serif',
    },
    foundations: {
        mobile: {
            body: FontLevels.BODY_MOBILE,
            h1: FontLevels.LEVEL_2,
            h2: FontLevels.LEVEL_3,
            h3: FontLevels.LEVEL_4,
            h4: FontLevels.LEVEL_5,
            h5: FontLevels.LEVEL_6,
            h6: FontLevels.LEVEL_7,
        },
        desktop: {
            body: FontLevels.BODY,
            h1: FontLevels.LEVEL_1,
            h2: FontLevels.LEVEL_2,
            h3: FontLevels.LEVEL_3,
            h4: FontLevels.LEVEL_4,
            h5: FontLevels.LEVEL_5,
            h6: FontLevels.LEVEL_6,
        },
    },
    weights: {
        ultralight: 100,
        light: 200,
        regular: 400,
        bold: 600,
    },
};
export default fonts;
//# sourceMappingURL=fonts.js.map